import { Component } from '@theme/component';
import Splide from '@theme/splide';

export class CsGridGallerySlider extends Component {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', this.splideInit.bind(this));
  }

  splideInit() {
    const topSliderEl = this.querySelector('[data-grid-gallery="top"]');
    if (topSliderEl) {
      const topSplide = new Splide(topSliderEl, {
        gap: 14,
        pagination: false,
        arrows: false,
        fixedWidth: '420px',
        perMove: 1,
        drag: true,
        type: 'loop',
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        pauseOnFocus: true,
        focus: 'left',
        trimSpace: false
      });
      topSplide.mount();
    }

    const bottomSliderEl = this.querySelector('[data-grid-gallery="bottom"]');
    if (bottomSliderEl) {
      const bottomSplide = new Splide(bottomSliderEl, {
        gap: 14,
        pagination: false,
        arrows: false,
        fixedWidth: '420px',
        perMove: 1,
        drag: true,
        type: 'loop',
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        pauseOnFocus: true,
        focus: 'left',
        trimSpace: false
      });
      bottomSplide.mount();
    }
  }
}

if (!customElements.get('cs-grid-gallery-slider')) {
  customElements.define('cs-grid-gallery-slider', CsGridGallerySlider);
}
